let requestConnectId = 0;
const USE_WEB_WORKER = false;


export default class DbApiCaller {


  get workerPath() { return dn.$store.getters['path/$join']('resources', `js/db/${USE_WEB_WORKER ? 'web-' : ''}worker.js`) }
  get isConnecting() { return this.state === 'connecting' }
  get isConnected() { return this.state === 'connected' }



  /**
   * constructor
   */
  constructor() {
    new EventManager(this);

    this._callIndex = 0;
    this.worker = null;
    this.state = 'pending';
  }



  /**
   * terminate
   */
  async terminate() {
    if (USE_WEB_WORKER) {
      await this.call('terminate');
      try { this.worker.terminate() } catch(e) {}
    }

    this.worker = null;
    this.state = 'pending';
  }



  /**
   * initialize
   */
  requestConnect() {
    return new Promise((resolve, reject) => {
      if (this.isConnected) return resolve();

      const myRequestConnectId = ++requestConnectId;

      this.one(`connect.${myRequestConnectId}`, () => {
        resolve();
      });

      if (this.isConnecting) return;

      this.state = 'connecting';

      const onSuccess = () => {
        this.call('init', {config: {year: dn.$store.state.config.year, rootPath: dn.$store.getters['path/$join']('root', 'db')}})
          .then(() => {
            this.state = 'connected';
            this.emit('connect');
            return null;
          })
          .catch(onError);
      }

      const onError = e => {
        this.state = 'connecterror';
        this.emit('connecterror');
        this.off(`connect.${myRequestConnectId}`);
        reject(e);
      }

      if (USE_WEB_WORKER) {
        this.worker = new Worker(this.workerPath);
        onSuccess();
      } else {
        dn.$http.get(this.workerPath)
          .then(res => {
            this.worker = window._DnDbApiReciever;
            return onSuccess();
          })
          .catch(onError);
      }
    });
  }



  /**
   * call worker method
   */
  call(action, params = {}, callbacks = {}) {
    return new Promise(async (resolve, reject) => {
      let dbStates;

      const onError = e => {
        return reject(e);
      }

      if (!params.skipSyncDbStates) {
        dbStates = dn.$store.getters['ls/at']('db_states', {});
      }

      if (action !== 'init') {
        try {
          await this.requestConnect();
        } catch(e) {
          return onError(e);
        }
      }

      const callIndex = ++this._callIndex;

      const listenerNames     = [];
      const callbackRecievers = {};
      for (let name in callbacks) {
        listenerNames.push(name);
        if (!USE_WEB_WORKER) callbackRecievers[name] = callbacks[name];
      }

      const onWorkerError = e => {
        removeWebWorkerListener();
        return onError(e);
      }

      const removeWebWorkerListener = () => {
        if (!USE_WEB_WORKER) return;
        this.worker.removeEventListener('message', onMessage, false);
        this.worker.removeEventListener('error', onWorkerError, false);
      }

      const onMessage = message => {
        const _data        = message.data || {},
              recieveIndex = _data._callIndex;

        if (recieveIndex !== callIndex) return;

        const type  = _data.type,
              data  = _data.data;

        const callbackMatch = type.match(/^cb\.(.*)$/);
        if (callbackMatch) {
          const callbackName = callbackMatch[1];
          return callbacks[callbackName](data);
        }

        removeWebWorkerListener();

        if (type === 'error') {
          return onError(new Error(data.message || data));
        }
        if (type === 'cb') return resolve(data);
      }

      const workerParams = Object.assign({}, {
        action            : action,
        _callIndex        : callIndex,
        _listenerNames    : listenerNames,
        _callbackRecievers: callbackRecievers,
        _dbStates         : dbStates,
      }, params);

      if (USE_WEB_WORKER) {
        this.worker.addEventListener('message', onMessage, false);
        this.worker.addEventListener('error', onWorkerError, false);
        this.worker.postMessage(workerParams);
      } else {
        const res = await this.worker({data: workerParams});
        onMessage(res);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/manager/DbManager/DbApiCaller.js